// import { createApp } from 'vue';
import createApp from '@/utils/createApp'
import { Modal } from "ant-design-vue";
import ConfirmDialog from "ant-design-vue/lib/modal/ConfirmDialog";


import Omit from 'omit.js';

const destroyFns = [];

function install() {
    var destroyAll = Modal.destroyAll
    Modal.destroyAll = function destroyAllFn() {
        destroyAll()
        while (destroyFns.length) {
            const close = destroyFns.pop();
            if (close) {
                close();
            }
        }
    };
}
export { install }

export default function Dialog(props) {
    const div = document.createElement('div');
    div.id = `Dialog-${new Date().getTime() * 1000 + parseInt(Math.random() * 1000)}`
    document.body.appendChild(div);
    var config = {
        type: 'confirm',
        okCancel: false,
        width: 1200,
    }
    let currentConfig = { ...Omit(config, ['parentContext']), close, visible: true, ...props };

    let confirmDialogInstance = null;
    let confirmDialogProps = {};
    function close() {
        currentConfig = {
            ...currentConfig,
            visible: false,
            afterClose: destroy,
        };
        update(currentConfig);
    }
    function update(newConfig) {
        currentConfig = {
            ...currentConfig,
            ...newConfig,
        };
        confirmDialogInstance &&
            Object.assign(confirmDialogInstance, { confirmDialogProps: currentConfig });
    }
    function destroy(args) {
        if (confirmDialogInstance && div.parentNode) {
            confirmDialogInstance.vIf = false; // hack destroy
            confirmDialogInstance = null;
            div.parentNode.removeChild(div);
        }
        const triggerCancel = args?.some(param => param && param.triggerCancel);
        if (config.onCancel && triggerCancel) {
            config.onCancel(...args);
        }
        for (let i = 0; i < destroyFns.length; i++) {
            const fn = destroyFns[i];
            if (fn === close) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }

    function render(props) {
        confirmDialogProps = props;
        return createApp({
            parent: config.parentContext,
            data() {
                return { confirmDialogProps, vIf: true };
            },
            render() {
                // 先解构，避免报错，原因不详
                const cdProps = { ...this.confirmDialogProps, };
                return this.vIf ? <ConfirmDialog {...cdProps} /> : null;
            },
        }).mount(div);
    }

    confirmDialogInstance = render(currentConfig);
    destroyFns.push(close);
    return {
        destroy: close,
        update,
    };
}
